import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import 'bootstrap-icons/font/bootstrap-icons.css';
import QuestionnaireJury from './QuestionnaireJury';
import {getAllUserAnswersArchivo,getFileAnswer} from '../actions/questionActions'
import { downloadProposal } from '../actions/proposalActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileArrowDown} from '@fortawesome/free-solid-svg-icons';

const ApplicationFormJury = ({ navigateToApplicationForm }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { userInfo } = useSelector(state => state.user);
    const { proposalId } = useParams();
    const { proposals } = useSelector(state => state.proposal);
    const [proposal, setProposal] = useState(null);
    const userAnswersArchivo = useSelector(state => state.question.userAnswersArchivo);

    const handleBack = () => {
        navigate('/backoffice');
    };

    useEffect(() => {
        const foundProposal = proposals.find(x => x.Id === proposalId);
        setProposal(foundProposal);
    }, [proposalId, proposals]);

    useEffect(() => {
        if (proposal) {
            dispatch(getAllUserAnswersArchivo(userInfo, proposal.id_usuario, proposal.Id));
        }
    }, [proposal, userInfo, dispatch]);

    const handleDownloadProposal = () => {
        dispatch(downloadProposal(userInfo, proposalId));
    };

    const handleDownloadFile = (FileId,FileName) => {
        dispatch(getFileAnswer(FileId,FileName,userInfo))
    };
    return (
        <div className='contReduce' style={{ marginBottom: '20px' }}>
            <section className="container1">
                <div className='row mb-5'>
                    <div className='col-lg-4 col-md-6 col-sm-6'>
                        <a className="btn_back" onClick={handleBack}>
                            Volver al home
                        </a>
                    </div>

                </div>


                <div>
                    <h2>Formulario para evaluación de Microcredenciales</h2>
                    <div className='col-12 container-question' >
                        <div className='row'>
                            <div className='col-lg-11 col-md-11 col-sm-12'> Estimado evaluador: <br></br>Le solicitamos que valore la calidad de la propuesta de microcredenciales considerando la totalidad de los indicadores que se incluyen en el formulario.</div>
                        </div>
                        <br></br>
                        <div className='row'>
                            <div className=' d-flex center-container'>
                                <button id="downloadProposal" className="btn btn-primary" onClick={handleDownloadProposal}>Descargar propuesta</button>
                                <div className="dropdown">
                                    <a className="btnDropdown btn-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false" style={{position: 'absolute', top: '50%', transform: 'translateY(-50%)', left: '5px', fontSize: '1.5em;'}}>
                                        <FontAwesomeIcon icon={faFileArrowDown} />
                                    </a>
                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                        {userAnswersArchivo.length > 0 ? (
                                            userAnswersArchivo.map((answer, index) => (
                                                <li key={index}>
                                                    <a className="dropdown-item" onClick={() =>handleDownloadFile(answer.rutaArchivo, answer.nombreArchivo)}>
                                                        Descargar {answer.preguntaAsociada.seccion.titulo}: {answer.nombreArchivo.split("_file_")[1]}
                                                    </a>
                                                </li>
                                            ))
                                        ):<></>}
                                    </ul>
                                </div>
                            </div>
                            
                        </div>
                        
                    </div>

                    <QuestionnaireJury />
                </div>

            </section>

        </div>
    );
};
export default ApplicationFormJury;
